module.exports = __webpack_public_path__ + "static/fonts/HelveticaNeue.ccad04d.ttf";